import PropTypes from 'prop-types'

const BankIcon = ({ stroke = 'white', width = 24, height = 24 }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 24 25" fill="none">
      <path
        d="M5 9.52346V17.5235M9.5 9.52346V17.5235M14.5 9.52346V17.5235M19 9.52346V17.5235M3 19.1235L3 19.9235C3 20.4835 3 20.7635 3.10899 20.9774C3.20487 21.1656 3.35785 21.3186 3.54601 21.4145C3.75992 21.5235 4.03995 21.5235 4.6 21.5235H19.4C19.9601 21.5235 20.2401 21.5235 20.454 21.4145C20.6422 21.3186 20.7951 21.1656 20.891 20.9774C21 20.7635 21 20.4835 21 19.9235V19.1235C21 18.5634 21 18.2834 20.891 18.0695C20.7951 17.8813 20.6422 17.7283 20.454 17.6325C20.2401 17.5235 19.9601 17.5235 19.4 17.5235H4.6C4.03995 17.5235 3.75992 17.5235 3.54601 17.6325C3.35785 17.7283 3.20487 17.8813 3.10899 18.0695C3 18.2834 3 18.5634 3 19.1235ZM11.6529 3.60059L4.25291 5.24503C3.80585 5.34438 3.58232 5.39405 3.41546 5.51426C3.26829 5.62029 3.15273 5.76435 3.08115 5.93102C3 6.11998 3 6.34897 3 6.80693L3 7.92346C3 8.48351 3 8.76354 3.10899 8.97745C3.20487 9.16561 3.35785 9.31859 3.54601 9.41446C3.75992 9.52346 4.03995 9.52346 4.6 9.52346H19.4C19.9601 9.52346 20.2401 9.52346 20.454 9.41446C20.6422 9.31859 20.7951 9.16561 20.891 8.97745C21 8.76354 21 8.48351 21 7.92346V6.80693C21 6.34897 21 6.11998 20.9188 5.93102C20.8473 5.76435 20.7317 5.62029 20.5845 5.51426C20.4177 5.39405 20.1942 5.34438 19.7471 5.24503L12.3471 3.60059C12.2176 3.57181 12.1528 3.55741 12.0874 3.55167C12.0292 3.54658 11.9708 3.54658 11.9126 3.55167C11.8472 3.55741 11.7824 3.57181 11.6529 3.60059Z"
        stroke={stroke}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

BankIcon.propTypes = {
  stroke: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
}

export default BankIcon
